import {useEffect, useState} from "react";
import {getGroupItemList} from "../../../../../core/api/optionApis";
import {useSelector} from "react-redux";


const usePartOptionController = (partArray, stepObject) => {
  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);
  const [fetchedPartGroups, setFetchedPartGroups] = useState({});
  const [isLoading, setIsLoading] = useState(true); // 초기 로딩 상태는 true로 설정

  const [processedParts, setProcessedParts] = useState({
    single: [],
    grouped: []
  });

  useEffect(() => {
    let isMounted = true;

    if (!partArray || !Array.isArray(partArray)) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);


    const uniquePartGroupIds = new Set();
    const tempSingleParts = [];
    const tempGroupedParts = [];

    partArray.forEach(partItem => {
      if (partItem.isSingle || partItem.isSingle === undefined) {
        tempSingleParts.push(partItem);
      } else if (partItem.isSingle === false) {
        tempGroupedParts.push(partItem);
        if (partItem.partGroupId) {
          uniquePartGroupIds.add(partItem.partGroupId);
        }
      }
    });

    setProcessedParts({
      single: tempSingleParts,
      grouped: tempGroupedParts
    });


    if (uniquePartGroupIds.size === 0) {
      setIsLoading(false);
      return;
    }


    const fetchPromises = Array.from(uniquePartGroupIds).map(groupId =>
      getGroupItemList(currentProduct.id, stepObject.stepType, groupId)
        .then(res => {
          if (res.data.result && res.data.message === "SUCCESS") {
            return {[groupId]: res.data.data.partGroupItems};
          }
          return {[groupId]: []};
        })
        .catch(err => {
          console.error(`Part group(${groupId}) request error :`, err);
          return {[groupId]: []};
        })

    );


    Promise.all(fetchPromises)
      .then(results => {
        if (!isMounted) return;
        const newFetchedPartGroups = results.reduce((acc, current) => ({
          ...acc,
          ...current
        }), {});
        setFetchedPartGroups(newFetchedPartGroups);
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        if (isMounted) { // unmount 체크
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [partArray, currentProduct.id, stepObject.stepType]);





  const findSelectedPartItem = (stepObject, codeKeyData, personalItemObject) => {
    let partSwitch;
    let selectedIndex = 0;
    let selectedItem;
    const { single: singleParts, grouped: groupedParts } = processedParts;
    const findSelected = (codeKeyData, switchType, switchKey, personalItemObject) => {
      if(!partArray && personalItemObject){
        if((codeKeyData) && (codeKeyData.CODE === personalItemObject.partPersonalization.code)) {
          partSwitch = personalItemObject.partPersonalization.code;
          selectedItem  = personalItemObject;
        } else {
          partSwitch = "";
          selectedItem = null;
        }
      } else if(partArray) {
        if (singleParts.length > 0) {
          singleParts.find((item, index) => {

            if((codeKeyData) && item[switchType].code === codeKeyData?.CODE) {
              selectedIndex = index;
              selectedItem = item;
            }

          });
        }


        if (groupedParts.length > 0) {
          groupedParts.find((partItem, index) => {

            const partGroupItems = fetchedPartGroups[partItem.partGroupId];
            partGroupItems?.find((item, index) => {
              if((codeKeyData) && item.code === codeKeyData?.CODE) {
                selectedIndex = index;
                selectedItem = item;
              }
            })
          })
        }

        if (selectedItem) {
          partSwitch = selectedItem[switchType]?.[switchKey] || selectedItem["switchKey"];
        }
      }
    }

    let switchType;
    let switchKey;
    switch (stepObject.stepType) {
      case "PART_3D":
        switchType = "partSwitch";
        switchKey = "partCategory";
        findSelected(codeKeyData, switchType, switchKey);
        break;

      case "MATERIAL":
        switchType = "materialSwitch";
        switchKey = "type";
        findSelected(codeKeyData, switchType, switchKey);
        break;

      case "PART_2D":
        switchType = "partPersonalization";
        switchKey = "code";
        findSelected(codeKeyData, switchType, switchKey, personalItemObject);
        break;

      default:
        switchType = "";
        switchKey = "";
    }

    return { partSwitch, selectedItem, selectedIndex };
  }


  return { findSelectedPartItem, fetchedPartGroups, isLoading, processedParts }
}
export default usePartOptionController;
